const features = [
  {
    title: 'interiors.features.0.title',
    list: [
      'interiors.features.0.list.0',
      'interiors.features.0.list.1',
      'interiors.features.0.list.2',
      'interiors.features.0.list.3',
      'interiors.features.0.list.4',
      'interiors.features.0.list.5',
    ],
  },
  {
    title: 'interiors.features.1.title',
    list: [
      'interiors.features.1.list.0',
      'interiors.features.1.list.1',
      [
        'interiors.features.1.list.2.0',
        'interiors.features.1.list.2.1',
        'interiors.features.1.list.2.2',
        'interiors.features.1.list.2.3',
        'interiors.features.1.list.2.4',
      ],
      'interiors.features.1.list.3',
      'interiors.features.1.list.4',
      'interiors.features.1.list.5',
      'interiors.features.1.list.6',
      'interiors.features.1.list.7',
      'interiors.features.1.list.8',
    ],
  },
  {
    title: 'interiors.features.2.title',
    list: [
      'interiors.features.2.list.0',
      'interiors.features.2.list.1',
      'interiors.features.2.list.2',
      'interiors.features.2.list.3',
      'interiors.features.2.list.4',
      'interiors.features.2.list.5',
    ],
  },
  {
    title: 'interiors.features.3.title',
    list: [
      'interiors.features.3.list.0',
      'interiors.features.3.list.1',
      'interiors.features.3.list.2',
    ],
  },
  {
    title: 'interiors.features.4.title',
    list: [
      'interiors.features.4.list.0',
      'interiors.features.4.list.1',
      'interiors.features.4.list.2',
      'interiors.features.4.list.3',
      'interiors.features.4.list.4',
      'interiors.features.4.list.5',
      'interiors.features.4.list.6',
    ],
  },
  {
    title: 'interiors.features.5.title',
    list: [
      'interiors.features.5.list.0',
      'interiors.features.5.list.1',
      'interiors.features.5.list.2',
      'interiors.features.5.list.3',
      'interiors.features.5.list.4',
      'interiors.features.5.list.5',
    ],
  },
];

export default features;



// WEBPACK FOOTER //
// ./src/data/features.js